export default {
	name: 'TaskStatusLookup',
	options: {
		tablename: 'task_status_lookup',
		schema: 'public',
		sortfield: 'status'
	}
};

